export const userAr = {
  "Nom d'utilisateur Deja existe": "اسم المستخدم موجود بالفعل",
  "Nom d'utilisateur est obligatoire": "اسم المستخدم الزامي",
  "Mot de passe est obligatoire": "كلمة المرور الزامية",
  "Mot de passe": "كلمة المرور",
  "Numero de telephone est obligatoire": "رقم الهاتف الزامي",
  "Donner au moins un role": "إعط دور واحد على الأقل",  
}